import AttachmentComposerChipDoc from './AttachmentComposerChipDoc'
import AttachmentComposerChipImage from './AttachmentComposerChipImage'

export default function AttachmentComposerChip({ item, onRemove, onOpenImageGallery }) {
  const { file, previewUrl, id, uploadState, uploadError } = item

  if (previewUrl) {
    return (
      <AttachmentComposerChipImage
        file={file}
        previewUrl={previewUrl}
        uploadState={uploadState}
        onRemove={() => onRemove(id)}
        onOpenImageGallery={onOpenImageGallery}
      />
    )
  }

  return (
    <AttachmentComposerChipDoc
      file={file}
      uploadState={uploadState}
      uploadError={uploadError}
      onRemove={() => onRemove(id)}
    />
  )
}
